/**
 * 公告信息
 * Bai.Zhiming
 * 2019-6-25
 */
angular.module('noticeInfoModule', [])
    .controller('noticeInfoCtrl', ['$scope', '$q', 'trsHttpService', 'modalDialog', '$state', 'messageCenterService', 'trsspliceString','noticeService',
        function($scope, $q, trsHttpService, modalDialog, $state, messageCenterService, trsspliceString, noticeService) {
            initStatus();
            initData();
            listenerStorage();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    typeList: [{ name: '全部', value: 0 }],
                    hotLists: {
                        page: {
                            'pn': 1,
                            'PAGESIZE': 20,
                            'PAGECOUNT': 0,
                            'ITEMCOUNT': 0
                        },
                        status: {
                            'jumpToPageNum': 1,
                            'startpage': 0
                        }
                    },
                    typeId: $state.params.id,
                    hasReadArr: [], // 判断是否已读列表
                };
                $scope.data = {
                    keywords: '',
                    selectedArray: []
                };
            }

            /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
            function initData() {
                getTypeList().then(() => requestData());
            }

            /**
         * [getTypeList description]  获取公告类型数据
         * @return {[type]} [description]
         */
            function getTypeList() {
                let defer = $q.defer();
                let params = {
                    serviceid: 'noticetype',
                    method: 'noticetype',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then(function(data) {
                    let optionsList = data.data.map((_item) => ({ name: _item.typename, value: _item.typeid }));
                    $scope.status.typeList = $scope.status.typeList.concat(optionsList);
                    $scope.status.selectedType = $scope.status.typeList[0];
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
         * [requestData description] 获取公告数据
         * @return {[type]} [description]
         */
            function requestData() {
                let defer = $q.defer();
                let params = {
                    serviceid: 'notice',
                    method: 'receivedNoticeList',
                    pageNumber: $scope.status.hotLists.page.pn,
                    pageSize: $scope.status.hotLists.page.PAGESIZE,
                    keyWords: $scope.data.keywords,
                    typeid: $scope.status.typeId
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then(function(data) {
                    if (data.data) {
                        $scope.data.noticesList = data.data.content;

                        $scope.status.hotLists.page.pn = data.data.number + 1;
                        $scope.status.hotLists.page.PAGESIZE = data.data.size;
                        $scope.status.hotLists.page.PAGECOUNT = data.data.totalPages;
                        $scope.status.hotLists.page.ITEMCOUNT = data.data.totalElements;

                        hasRead();
                    }

                    defer.resolve();
                });
                return defer.promise;
            }

            /**
         * [isChecked description] 判断是否选中
         * @param  {[type]}  item [description] 公告
         * @return {Boolean}      [description]
         */
            $scope.isChecked = function(item) {
                return $scope.data.selectedArray.some((_item) => _item.noticeid == item.noticeid);
            };

            /**
             * [selectItem description] 公告选择/取消选择
             * @param  {[type]} item [description] 公告
             * @return {[type]}      [description]
             */
            $scope.selectItem = function(item) {
                if ($scope.isChecked(item)) {
                    var index = $scope.data.selectedArray.indexOf(item);
                    $scope.data.selectedArray.splice(index, 1);
                } else {
                    $scope.data.selectedArray.push(item);
                }
            };

            /**
             * [selectAll description] 全选/取消全选
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                if ($scope.data.selectedArray.length == $scope.data.noticesList.length && $scope.data.noticesList.length > 0) {
                    $scope.data.selectedArray = [];
                } else {
                    $scope.data.selectedArray = [].concat($scope.data.noticesList);
                }
            };

            /**
             * [requestData description] 数据请求
             * @param  {[type]} ev [description]
             * @return {[type]}    [description]
             */
            $scope.requestData = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    requestData();
                }
            };

            /**
             * [searchFn description] 搜索函数
             */
            $scope.searchFn = function() {
                clearPage();
                requestData();
             
            };

            /**
             * [pageChanged description]分页请求
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.status.hotLists.status.jumpToPageNum = $scope.status.hotLists.page.pn;
                $scope.status.hotLists.page.startpage = $scope.status.hotLists.page.pn - 1;
                requestData();
            };
            $scope.jumpToPage = function() {
                if ($scope.status.hotLists.status.jumpToPageNum > $scope.status.hotLists.page.PAGECOUNT) {
                    $scope.status.hotLists.status.jumpToPageNum = $scope.status.hotLists.page.PAGECOUNT;
                }
                if ($scope.status.hotLists.status.jumpToPageNum === '0' || isNaN(Number($scope.status.hotLists.status.jumpToPageNum))) {
                    modalDialog.alertType('请输入合法的页码', '', 'warning', false);
                    return;
                }
                $scope.status.hotLists.page.startpage = $scope.status.hotLists.status.jumpToPageNum - 1;
                $scope.status.hotLists.page.pn = $scope.status.hotLists.status.jumpToPageNum;
                requestData();
            };

            /**
         * [clearPage  description] 清除page信息
         */
            function clearPage() {
                $scope.status.hotLists = {
                    page: {
                        'pn': 0,
                        'PAGESIZE': 20,
                        'PAGECOUNT': 0,
                        'ITEMCOUNT': 0
                    },
                    status: {
                        'jumpToPageNum': 1,
                        'startpage': 0
                    }
                };
            }

            /**
             * [hasRead description]  判断是否已读
             */
            function hasRead() {
                var noticeids = trsspliceString.spliceString($scope.data.noticesList, 'noticeid', ',');
                messageCenterService.hasRead(noticeids).then((data) => {
                    $scope.status.hasReadArr = data.data;
                    $scope.data.noticesList.forEach((notices, i) => {
                        for (var hasReadArr in $scope.status.hasReadArr) {
                            if (notices.noticeid == hasReadArr) {
                                notices.isRead = $scope.status.hasReadArr[hasReadArr];
                            }
                        }
                    });
                });
            }

            /**
         *[requestData description] 标记为已读
         * @param  {[type]}  [description] 类型（0:已选数据标记为已读 1:全部标记为已读）
         * @return {[type]}    [description]
         */
            $scope.markAsRead = function(type) {
                var opertype = type;
                var noticeids = trsspliceString.spliceString($scope.data.selectedArray, 'noticeid', ',');
                if (type == 0) {
                    messageCenterService.readNotices(noticeids, !!opertype).then((data) => {
                        requestData();
                        modalDialog.alertType('设置成功', '', 'success', false);
                    });
                } else {
                    noticeids = trsspliceString.spliceString($scope.data.noticesList, 'noticeid', ',');
                    messageCenterService.readNotices(noticeids, !!opertype).then((data) => {
                        requestData();
                        modalDialog.alertType('设置成功', '', 'success', false);
                    });
                }
                $scope.data.selectedArray = [];
            };

            /**
             * listenerStorage 监听storage，刷新页面，变为已读
             */
            function listenerStorage() {
                localStorage.removeItem('gotoNoticeDetail');
                let listener = window.addEventListener('storage', (e) => {
                    if (e.key == 'gotoNoticeDetail') {
                        requestData();
                        localStorage.removeItem('gotoNoticeDetail');
                    }
                });
                $scope.$on('$destroy', () => {
                    window.removeEventListener('storage', listener);
                });
            }

            /**
             * [goToPreview description]约稿通知
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.goToPreview = function(item) {
                if (item.typename === '约稿通知') {
                    noticeService.MCpreviewForManu(item).then((data) => {

                    });
                } else {
                    let url = 'systemnoticedetail';
                    $state.go(url, {noticeid: item.noticeid});
                }
            };
        }
    ]);
